export default [
  {
    id: 0,
    name: "김정수",
    image: "/images/front1.png",
    detail: "김정수",
    vote: 7,
  },
  {
    id: 1,
    name: "박준열",
    image: "/images/front2.png",
    detail: "박준열",
    vote: 5,
  },
  {
    id: 2,
    name: "구본준",
    image: "/images/front3.png",
    detail: "구본준",
    vote: 5,
  },
  {
    id: 3,
    name: "김주현",
    image: "/images/front4.png",
    detail: "김주현",
    vote: 4,
  },
  {
    id: 4,
    name: "김태은",
    image: "/images/front5.png",
    detail: "김태은",
    vote: 3,
  },
  {
    id: 5,
    name: "김현재",
    image: "/images/front6.png",
    detail: "김현재",
    vote: 3,
  },

  {
    id: 6,
    name: "양기욱",
    image: "/images/front7.png",
    detail: "양기욱",
    vote: 2,
  },
  {
    id: 7,
    name: "유시원",
    image: "/images/front8.png",
    detail: "유시원",
    vote: 1,
  },
  {
    id: 8,
    name: "이로움",
    image: "/images/front9.png",
    detail: "이로움",
    vote: 1,
  },
];
